import { render, staticRenderFns } from "./BaseProducts.vue?vue&type=template&id=b01c8c6c&scoped=true&"
var script = {}
import style0 from "./BaseProducts.vue?vue&type=style&index=0&id=b01c8c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01c8c6c",
  null
  
)

export default component.exports